import { gql } from "@apollo/client";
import { BasicQueryInfoInput } from "../../FeedDataCalls/GQLCalls/getFeedComponentsCall";

export interface ExtendedCompany {
    company_id: number
    domain: string
    name: string
    tags?: string[]
    pin?: number
    vpn_address?: string
    city?: string
    street?: string
    phone?: string
    vat?: string
    email?: string
    legacy: boolean
}

export const EXTENDED_COMPANIES = gql`
query ExtendedCompanies($input: BasicQueryInfoInput) {
	user {
		extendedCompanies(input: $input) {
			company_id
			domain
			name
			tags
			pin
			vpn_address
			city
			street
			phone
			vat
			email
			legacy
		}
	}
}
`

export interface ExtendedCompaniesResponse {
	user: {
		extendedCompanies: ExtendedCompany[]
	}
}

export interface ExtendedCompaniesArgs {
	input?: BasicQueryInfoInput;
}

